import React, { useRef, useCallback, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import iconoCompartir from "../../assets/imgs/detalle_blog/share-white.svg";
import iconoX from "../../assets/imgs/detalle_blog/logo-x.svg";
import iconoFacebook from "../../assets/imgs/detalle_blog/Asset_Facebook-normal.svg";
import iconoLinkedIn from "../../assets/imgs/detalle_blog/LinkedIn.svg";
import iconoMail from "../../assets/imgs/detalle_blog/Asset_Mail-Normalblanco.svg";
import iconoCopiar from "../../assets/imgs/detalle_blog/Link.svg";
import { useLocation } from "react-router-dom";

import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/virtual";

const Modal = ({ isOpen, closeModal, variable1, variable2, id_idea }) => {

  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const [images, setImages] = useState([]);
  const [liga, setLiga] = useState();
  const [btn, setBtn] = useState(
    ``
  );

  const handleX = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea="+id_idea
      )}&text=${encodeURIComponent("Idea en corto")}`,
      "_blank"
    );
  };

  const handleFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea="+id_idea)}`,
      "_blank"
    );
  };

  const handleLinkedIn = (e) => {
    window.open(
      `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
        "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea="+id_idea
      )}&title=${encodeURIComponent("Idea en corto")}`,
      "_blank"
    );
  };

  const handleMail = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(
      "Idea en corto"
    )}&body=${encodeURIComponent("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea="+id_idea)}`;
  };

  const handleCopiarURL = () => {
    navigator.clipboard.writeText("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea="+id_idea).then(() => {
      alert('¡Enlace copiado al portapapeles!');
    }).catch((error) => {
      console.error('Error al copiar al portapapeles:', error);
    });
  };

  useEffect(() => {
    if (!isOpen) return;

    try {
      const imageUrls = variable1.match(/src="([^"]+)"/g).map((src) => src.match(/"([^"]+)"/)[1]);
      setImages(imageUrls)
    } catch (e) {
      if (variable2 === 'video') {
        console.log("Es video");
        const dummyImages = ['dummy1.jpg', 'dummy2.jpg', 'dummy3.jpg'];
        setImages(dummyImages);
      }
    };



    try {
      const ligaUrls = variable1.match(/href="([^"]+)"/g).map((src) => src.match(/"([^"]+)"/)[1]);
      setBtn(`<a class='btn-idea-blog-a' href='` + ligaUrls + `' >Leer blog</a>`);

    } catch (e) {
      console.log("sin liga")
    };



  }, [isOpen]);

  if (!isOpen || images.length === 0) return null;

  if (variable2 === 'carrete') {
    return (
      <div className="modal">
        <div className="modalContent">
          <div className='div-f-carrusel'>
            <Swiper
              ref={sliderRef}
              spaceBetween={10}
              modules={[Autoplay, Navigation, Pagination]}
              effect="carousel"
              grabCursor={true}
              navigation={{
                nextEl: '.swiper-button-next', // Specify the correct selector for the next button
                prevEl: '.swiper-button-prev', // Specify the correct selector for the previous button
              }}
              pagination={{ clickable: true }}
              className="modal-swiper"
            >
              {images.map((imageUrl, index) => (
                <SwiperSlide key={index}>
                  <img className='swipperImage' src={imageUrl} alt={`Slide ${index + 1}`} />
                </SwiperSlide>
              ))}
            </Swiper>
            <div
              className="swiper-button-next"
              onClick={() => {
                // handleNext();
              }}
            />
            <div
              className="swiper-button-prev"
              onClick={() => {
                // handlePrev();
              }}
            ></div>
          </div>
          <div className='btn-idea-blog' dangerouslySetInnerHTML={{ __html: btn }} />
          <button className="botonPop" onClick={closeModal}>
            <span aria-hidden="true">×</span>
          </button>
          <div className="barra_texto_Desk_div barra_texto_Desk_div_carrusel">
              <div className="barra_texto_Desk">
                <button>
                  <div className="container-imagen">
                    <img src={iconoCompartir} alt="icono compartir" />
                  </div>
                  <ul className="socials" onClick={(e) => e.stopPropagation()}>
                    <li>
                      <img src={iconoX} alt="icono x" onClick={handleX} />
                    </li>
                    <li>
                      <img
                        src={iconoFacebook}
                        alt="icono facebook"
                        onClick={handleFacebook}
                      />
                    </li>
                    <li>
                      <img
                        src={iconoLinkedIn}
                        alt="icono linkedIn"
                        onClick={handleLinkedIn}
                      />
                    </li>
                    <li>
                      <img src={iconoMail} alt="icono mail" onClick={handleMail} />
                    </li>
                    <li>
                      <img
                        src={iconoCopiar}
                        alt="icono copiar url"
                        onClick={handleCopiarURL}
                      />
                    </li>
                  </ul>
                </button>
              </div>
            </div>
        </div>
        <div className="background_gri"></div>
      </div>
    );
  } else {
    if (variable2 === 'video') {
      return (
        <div className="modal">
          <div className="modalContent">

            <div className='div_otro'>
              <video autoplay controls>
                <source src={variable1} type="video/mp4" />
              </video>
            </div>
            <button
              className="botonPop"
              onClick={() => {
                closeModal();
              }}
            >
              <span aria-hidden="true">×</span>
            </button>
            <div className="barra_texto_Desk_div">
              <div className="barra_texto_Desk">
                <button>
                  <div className="container-imagen">
                    <img src={iconoCompartir} alt="icono compartir" />
                  </div>
                  <ul className="socials" onClick={(e) => e.stopPropagation()}>
                    <li>
                      <img src={iconoX} alt="icono x" onClick={handleX} />
                    </li>
                    <li>
                      <img
                        src={iconoFacebook}
                        alt="icono facebook"
                        onClick={handleFacebook}
                      />
                    </li>
                    <li>
                      <img
                        src={iconoLinkedIn}
                        alt="icono linkedIn"
                        onClick={handleLinkedIn}
                      />
                    </li>
                    <li>
                      <img src={iconoMail} alt="icono mail" onClick={handleMail} />
                    </li>
                    <li>
                      <img
                        src={iconoCopiar}
                        alt="icono copiar url"
                        onClick={handleCopiarURL}
                      />
                    </li>
                  </ul>
                </button>
              </div>
            </div>
          </div>
          <div className="background_gri"></div>
        </div>
      );
    }
    else {
      variable1 = variable1.replace('leer entrada', 'Leer blog');
      return (
        <div className="modal">
          <div className="modalContent">
            <div className='div_otro' dangerouslySetInnerHTML={{ __html: variable1 }} />
            <button
              className="botonPop"
              onClick={() => {
                closeModal();
              }}
            >
              <span aria-hidden="true">×</span>
            </button>
            <div className="barra_texto_Desk_div">
              <div className="barra_texto_Desk">
                <button>
                  <div className="container-imagen">
                    <img src={iconoCompartir} alt="icono compartir" />
                  </div>
                  <ul className="socials" onClick={(e) => e.stopPropagation()}>
                    <li>
                      <img src={iconoX} alt="icono x" onClick={handleX} />
                    </li>
                    <li>
                      <img
                        src={iconoFacebook}
                        alt="icono facebook"
                        onClick={handleFacebook}
                      />
                    </li>
                    <li>
                      <img
                        src={iconoLinkedIn}
                        alt="icono linkedIn"
                        onClick={handleLinkedIn}
                      />
                    </li>
                    <li>
                      <img src={iconoMail} alt="icono mail" onClick={handleMail} />
                    </li>
                    <li>
                      <img
                        src={iconoCopiar}
                        alt="icono copiar url"
                        onClick={handleCopiarURL}
                      />
                    </li>
                  </ul>
                </button>
              </div>
            </div>
          </div>

          <div className="background_gri"></div>
        </div>
      );
    }
  }
};

export default Modal;